import { axios } from '@Root/API'

export const getAdditionalPermissions = path => {
	return axios.get(`get-permissions/additional/${path}`)
}
